export default __webpack_public_path__ + "static/media/new-plus-gray.ce96dbda.svg";